import { render, staticRenderFns } from "./UnternehmenList.vue?vue&type=template&id=69ab8ffe&scoped=true&"
import script from "./UnternehmenList.vue?vue&type=script&lang=ts&"
export * from "./UnternehmenList.vue?vue&type=script&lang=ts&"
import style0 from "./UnternehmenList.vue?vue&type=style&index=0&id=69ab8ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ab8ffe",
  null
  
)

export default component.exports